import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "zh",
    debug: true,
    resources: {
      en: {
        translation: {
          routeCompute: "Route planning",
          imageExtract: "Sea ice detection",
          startDate: "Start date",
          shipType: "Type of ship",
          fuel: "Fuel",
          iceCount: "Ice count",
          totalContainer: "Total container",
          faxType: "Fax rate",
          noIce: "Ordinary merchant ship",
          pc1: "Ice Class PC1 ship",
          startEnd: "Start/End point",
          cancel: "Cancel",
          setting: "Setting",
          submit: "Submit",
          reset: "Reset",
          startAndEndPointValidator: "Please setting start or end point.",
          temperature: "Temperature",
          port: "Port",
          factor: "Ice situation",
          longitude: "Longitude",
          latitude: "Latitude",
          boundary: "Draw a polygon",
          boundaryValidator: "Please setting boundary.",
          startTime: "Start time",
          status: "Status",
          thickness: "Thickness",
          concentration: "Concentration",
          risk: "Risk",
          km: "km",
          day: "days",
          timeEstimating: "Duration",
          oil: "Fuel",
          tons: "tons",
          outOfBoundary:
            "Please select the start or end point in the buffer range",
          outOfDate:
            "The opening date is in [2021-07-27, 2021-10-28] and [2022-07-24, 2022-10-13], please select the date in this interval",
          weatherPanel: "Temperature in the coming week",
          routeRangePanel: "Navigation window",
          riskLegend: "Risk index",
          iceSituation: "Sea ice along the route",
          n: "年通航次数",
          aer: "年度效益比（gCO2/dwt·nm）",
          aeco2: "年际碳排放（t/TEU）",
          acvc: "年际成本（$/TEU）",
          cvc: "单航次成本（$/TEU）",
          apvp: "年际利润（$/TEU）",
          eco2: "单航次碳排放（t/TEU）",
        },
      },
      zh: {
        translation: {
          routeCompute: "航道计算",
          imageExtract: "影像提取",
          startDate: "开始时间",
          shipType: "船舶类型",
          totalContainer: "装箱量",
          fuel: "燃料",
          iceCount: "冰区",
          faxType: "碳税",
          noIce: "普通商船",
          pc1: "破冰船",
          startEnd: "始 / 终点",
          cancel: "取消",
          setting: "设置",
          submit: "提交",
          reset: "重置",
          startAndEndPointValidator: "请设置起点和终点",
          temperature: "气温",
          port: "港口",
          factor: "沿途冰情",
          longitude: "经度",
          latitude: "纬度",
          boundary: "范围",
          boundaryValidator: "请设置范围。",
          startTime: "运行时间",
          status: "状态",
          thickness: "厚度",
          concentration: "密集度",
          risk: "风险值",
          km: "千米",
          day: "天",
          timeEstimating: "大约需要",
          oil: "Fuel",
          tons: "吨",
          outOfBoundary: "请在缓冲区范围内选取起始点或终点",
          outOfDate:
            "通航日期在[2021-07-27，2021a-10.28],[2022-07-24，2022-10-13]之间，请在此区间选择日期",
          weatherPanel: "近六天温度",
          routeRangePanel: "通航窗口",
          riskLegend: "风险值RIO",
          iceSituation: "沿途冰情",
          n: "年通航次数",
          aer: "年度效益比（gCO2/dwt·nm）",
          aeco2: "年际碳排放（t/TEU）",
          acvc: "年际成本（$/TEU）",
          cvc: "单航次成本（$/TEU）",
          apvp: "年际利润（$/TEU）",
          eco2: "单航次碳排放（t/TEU）",
        },
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
